import NoteTimelineRecordLayout from 'domain/recruiting/candidate/Timeline/note/shared/NoteTimelineRecordLayout';
import { CREATE_CANDIDATE_NOTE_PERMISSION } from 'domain/recruiting/candidate/Timeline/note/note/candidateNoteService';
import UpdateNoteForm from './form/UpdateNoteForm';
import CreateNoteForm from './form/CreateNoteForm';
import { CANDIDATE_TIMELINE_RECORDS_ALIAS } from 'domain/shared/candidate';

const useCandidateNoteItem = () => ({
  AddForm: CreateNoteForm,
  UpdateForm: UpdateNoteForm,
  isApplicable: (item: any) => item.note && item.type !== CANDIDATE_TIMELINE_RECORDS_ALIAS.SYSTEM_NOTE && true,
  source: 'note',
  urlPostfix: 'notes',
  RecordLayout: NoteTimelineRecordLayout,
  name: 'Note',
  permissionToCheck: CREATE_CANDIDATE_NOTE_PERMISSION,
});

export default useCandidateNoteItem;
